import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';

function* fetchFileNameByFactoryId({ jobImportHistoryOperationParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `job/getimportfilebyfactory`,
      params: jobImportHistoryOperationParams,
    });
    const jobImportHistoryOperationData = data;
    yield put(Actions.setJobImportHistoryOperation({ jobImportHistoryOperationData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* downloadImportFileByFileName({ fileName, factoryid, isErp, id }) {
  try {
    const { data } = yield call(api.get, {
      route: `job/geterpimportfilebyfileid/${id}/${fileName}`,
    });
    const downloadImportfileHistoryOperationData = data;
    yield put(Actions.setDownloadImportFileDataOperation({ downloadImportfileHistoryOperationData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_JOB_OPERATORS_OPERATION, fetchFileNameByFactoryId),
    takeLatest(ActionTypes.DOWNLOAD_IMPORT_FILE_BY_FILE_NAME, downloadImportFileByFileName),
  ]);
}
